import * as React from "react"

import * as styles from "./index.module.scss"

type Props = React.HTMLAttributes<HTMLDivElement>

const Container: React.FC<Props> = ({ className, ...otherProps }) => {
  return <div className={`${styles.container} ${className}`} {...otherProps} />
}

export default Container
